import Button from '@hellodarwin/core/lib/components/common/button';
import { fadeIn } from '@hellodarwin/core/lib/theme/keyframes';
import styled from 'styled-components';

export const ALCValidationCta = styled(Button)`
  && {
    color: ${({ theme }) => theme.colors.grey_1};

    &:hover,
    &:active {
      &:not(:disabled) {
        color: ${({ theme }) => theme.colors.grey_1};
      }
    }
  }
`;

export const FundingExplorerTotal = styled.div`
  animation: ${fadeIn} 500ms linear;
  opacity: 1;
  @media screen and (max-width: ${({ theme }) => theme.breakpoints.tablet}px) {
    flex-direction: column;
    align-items: flex-start;
  }
`;

export const FundingExplorerInline = styled.div`
  width: 100%;
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  gap: ${({ theme }) => theme.spacing.sm}px;
`;
